class Map {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;

        self.latitude = Number(self.elem.dataset.latitude);
        self.longitude = Number(self.elem.dataset.longitude);
    }

    init() {
        let self = this;

        self.initMap();
    }

    async initMap() {
        let self = this;

        let { Map } = await google.maps.importLibrary('maps');
        let { AdvancedMarkerElement } = await google.maps.importLibrary('marker');

        let center = {
            lat: self.latitude,
            lng: self.longitude,
        };

        self.map = new Map(self.elem, {
            center,
            zoom: 13,
            mapId: 'contact-map',
            mapTypeId: 'roadmap',
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false,
            clickableIcons: false,
            gestureHandling: 'cooperative',
        });

        self.marker = new AdvancedMarkerElement({
            position: center,
            map: self.map,
        });
    }
}

export default Map;